<template>
  <div class="pay-fail">
    <CloseIcon class="pay-fail__icon" />
    <div class="pay-fail__h1">{{ $t('zhi-fu-shi-bai') }}</div>
    <div class="pay-fail__h2">{{ $t('qing-zhong-xin-zhi-fu') }}</div>
    <div v-if="needRepayBtn">
      <Button :variant="'purple'" type="button" class="mt-[36px] w-[120px]" @click="emits('back')">
        {{ $t('zhong-xin-zhi-fu') }}
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts" name="PayFail">
// 支付失败提示：可选显示“重新支付”按钮，触发外部回退/重试
import CloseIcon from '@rendora/design/assets/close.svg?component';
import Button from '@rendora/design/components/button/Button.vue';
withDefaults(defineProps<{ needRepayBtn?: boolean }>(), { needRepayBtn: true });
const emits = defineEmits(['back']);
</script>

<style lang="scss">
.pay-fail {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 270px;
  &__icon {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    color: var(--x-white-1);
    background-color: var(--x-error-6);
  }
  &__h1 {
    padding-top: 20px;
    padding-bottom: 16px;
    font-size: 24px;
    font-weight: bold;
    line-height: 34px;
  }
  &__h2 {
    font-size: 14px;
    line-height: 24px;
    opacity: 0.6;
  }
}
</style>
